import type { INavItem } from '@/types/navigation';

import { UserType } from '@/store/enums';
import {
  ADMIN_MENU_ITEMS,
  ADMIN_NAV_ITEMS,
  AGENT_NAV_ITEMS,
  CLIENT_NAV_ITEMS,
  COMMUNICATIONS_MENU_ITEMS,
  GIGS_MENU_ITEMS,
  SCHEDULES_MENU_ITEMS,
  REFER_MENU_ITEMS,
  ONBOARDING_MENU_ITEMS,
} from '@/constants';
import { IFeatureFlag } from '@/store/slices/featureFlags/types';

const getSubMenuNavItems = (menuName: INavItem['text'], userType: UserType): INavItem[] => {
  switch (menuName) {
    case 'Gigs':
      return GIGS_MENU_ITEMS();
    case 'Schedules':
      return SCHEDULES_MENU_ITEMS();
    case 'Admin':
      return ADMIN_MENU_ITEMS();
    case 'Refer a friend':
      return REFER_MENU_ITEMS();
    case 'Communications':
      return COMMUNICATIONS_MENU_ITEMS(userType);
    case 'Onboarding':
      return ONBOARDING_MENU_ITEMS();
    default:
      return [];
  }
};

const getNavItems = (userType: UserType, hasActiveGigs: boolean, featureFlags: IFeatureFlag): INavItem[] => {
  switch (userType) {
    case UserType.client:
      return CLIENT_NAV_ITEMS();
    case UserType.agent:
      return AGENT_NAV_ITEMS(hasActiveGigs, featureFlags);
    case UserType.admin:
      return ADMIN_NAV_ITEMS();
    default:
      return [];
  }
};

export { getSubMenuNavItems, getNavItems };
